import { FC } from 'react'
import { HeaderBar, IconButton, makeStyles, useMediaQuery } from '@perk-ui/core'
import { Menu } from 'react-feather'
import { useLocation } from 'react-router-dom'

import { pathsWithoutHeader } from '../config/constants'
import config from '../config/environments/development'
import { useAuth } from '../features/auth/AuthContext'
import AppLink from './AppLink'
import ProfileDropdown from './ProfileDropdown'

export interface AppHeaderProps {
  onMenuClick?: () => void
}

const useStyles = makeStyles((theme) => ({
  gap: {
    paddingRight: theme.spacing(3),
  },
  header: {
    zIndex: 1201,
    boxShadow: 'none',
  },
}))

const AppHeader: FC<AppHeaderProps> = ({ onMenuClick }) => {
  const classes = useStyles()
  const isMobile = useMediaQuery('(max-width: 899.95px)')
  const { isAuthenticated } = useAuth()
  const { pathname } = useLocation()
  const isCurrentLocation = (path: string) => pathname.startsWith(path)
  const showHeader = !pathsWithoutHeader.some(isCurrentLocation)

  return showHeader ? (
    <HeaderBar
      className={classes.header}
      left={
        <AppLink
          to={
            isAuthenticated
              ? config.authenticatedRootUrl
              : config.unAuthenticatedRootUrl
          }
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/DataBiologics_Logo.png`}
            height="30"
            style={{ display: 'block' }}
          />
        </AppLink>
      }
      right={
        isAuthenticated && (
          <>
            {!isMobile && <ProfileDropdown />}
            {isMobile && (
              <IconButton onClick={onMenuClick} sx={{ ml: 1 }}>
                <Menu size={20} />
              </IconButton>
            )}
          </>
        )
      }
      position="fixed"
    />
  ) : null
}

export default AppHeader
